const firebaseConfig = {
  apiKey: "AIzaSyDgLBHmLD2l6N8KRqMY6ESL62Gy92T5bHo",
  authDomain: "crypto-hunter-93428.firebaseapp.com",
  projectId: "crypto-hunter-93428",
  storageBucket: "crypto-hunter-93428.appspot.com",
  messagingSenderId: "918413561024",
  appId: "1:918413561024:web:449428b97ff9beb9fc3125"
};

export default firebaseConfig;
